import { useMemo } from 'react'
import {
  type AssignmentSiteTimes,
  assignmentSiteTimes,
} from '../helpers/assignmentSiteTimes'

/**
 * Site-based times when the assignment uses them (`usesOnsiteTimes`, decided
 * by the API), empty otherwise. Shared by the list card and the detail hero
 * so both screens agree.
 */
export const useAssignmentSiteTimes = (
  usesOnsiteTimes: boolean,
  waypoints: Parameters<typeof assignmentSiteTimes>[0],
): AssignmentSiteTimes =>
  useMemo(
    () => (usesOnsiteTimes ? assignmentSiteTimes(waypoints) : {}),
    [usesOnsiteTimes, waypoints],
  )
